import React, { Component } from "react";
import { Grid, Form, TextArea } from "semantic-ui-react";
import { ERR_TEXTBOX_NOT_FILLED } from "../../../ErrorMessages";
import InlineError from "../../messages/InlineError";

class MultiphoneControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.defaultData === undefined ? "" : props.defaultData,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.firstErrorFieldName &&
      nextProps.firstErrorFieldName === nextProps.control.FieldName
    ) {
      const element = document.getElementById(nextProps.control.FieldId);
      if (element) element.focus();
    }
    this.setState({
      value: nextProps.defaultData === undefined ? "" : nextProps.defaultData,
    });
  }
  onChange = (e, data) => {
    const value = this.formatPhone(data.value);
    if (this.props.notifyChangeToForm !== undefined)
      this.props.notifyChangeToForm(e, { name: data.name, value });
  };

  formatPhone = (phone) => {
    const only = false;

    let allnumbers = phone.replace("-", ""); // ctrl.value.replace("-", "");
    allnumbers = allnumbers.replace("-", "");

    allnumbers += ";";
    const anumbers = allnumbers.split(";");

    allnumbers = "";
    let val = "";
    for (let i = 0; i < anumbers.length - 1; i += 1) {
      val = anumbers[i];

      val = val.replace(/\D/g, "");

      if (val.length > 3) {
        val = `${val.substring(0, 3)}-${val.substring(3, 12)}`;
      }
      if (val.length > 7) {
        val = `${val.substring(0, 7)}-${val.substring(7, 12)}`;
      }

      if (val.length === 12 && !only) {
        val += ";";
      }
      allnumbers += val;
    }
    // clearForm(ctrl.form);
    // elements = document.querySelectorAll('.enableZone');
    // ctrl.value = allnumbers;
    return allnumbers;
  };

  render() {
    const { control, isLeftSearch } = this.props;
    const color = control.FieldRequired ? "red" : "black";
    return (
      <Grid.Row key={`txt_${control.FieldId}`}>
        <Grid.Column width={isLeftSearch ? 6 : 6}>
          <Form.Field>
            <label
              htmlFor={control.FieldLabel}
              style={{ color }}
              className="padding-5"
            >
              {control.FieldLabel}
            </label>
          </Form.Field>
        </Grid.Column>
        <Grid.Column width={isLeftSearch ? 10 : 10}>
          <Form.Field error={!!control.error}>
            <TextArea
              id={control.FieldId}
              name={control.FieldName}
              placeholder={control.FieldLabel}
              onChange={this.onChange}
              value={this.state.value}
              rows={5}
            />
            {this.props.errors[control.FieldName] !== undefined &&
              this.props.errors[control.FieldName] !== "" && (
                <InlineError text={ERR_TEXTBOX_NOT_FILLED} />
              )}
          </Form.Field>
        </Grid.Column>
      </Grid.Row>
    );
  }
}

export default MultiphoneControl;



// WEBPACK FOOTER //
// ./src/components/forms/controls/MultiphoneControl.js